import { useEffect, useRef, useState } from 'react';
import * as Styled from './CollapseContainer.styles';

export interface CollapseContainerProps {
  children: any;
  isOpen: boolean;
  /**
   * Duration of the open/close transition in ms
   */
  transitionDuration?: number;
  /**
   * Delay of the open/close in ms
   */
  delay?: number;
  /**
   * Some applications require the container to be display: flex when visible
   */
  displayValueWhenVisible?: 'block' | 'flex';
}

const CollapseContainer = ({
  delay,
  isOpen = false,
  transitionDuration = 250,
  children,
  displayValueWhenVisible = 'block',
  ...props
}: CollapseContainerProps) => {
  const [height, setHeight] = useState<number | null>(0);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = containerRef.current;
    let delayTimeout: number;
    let timeout: number;

    function handleEffect() {
      if (el) {
        if (isOpen === true) {
          el.style.display = displayValueWhenVisible;
          setHeight(el.scrollHeight);
          timeout = window.setTimeout(() => {
            setHeight(null);
          }, transitionDuration + 20);
        } else {
          setHeight(el.scrollHeight);
          timeout = window.setTimeout(() => {
            setHeight(0);
            timeout = window.setTimeout(() => {
              el.style.display = 'none';
            }, transitionDuration);
          }, 20);
        }
      }
    }

    if (delay && delay > 0) {
      delayTimeout = window.setTimeout(handleEffect, delay);
    } else {
      handleEffect();
    }

    return () => {
      window.clearTimeout(delayTimeout);
      window.clearTimeout(timeout);
    };
  }, [isOpen, delay, transitionDuration]);

  return (
    <Styled.Container
      ref={containerRef}
      style={{ height: height !== null ? height + 'px' : undefined }}
      $transitionDuration={transitionDuration}
      aria-hidden={!isOpen}
      {...props}>
      {children}
    </Styled.Container>
  );
};

export default CollapseContainer;
